let mutations = {
    left_menu(state, option) {
        if (option == "open") {
            state.left_open = true
        } else if (option == "close") {
            state.left_open = false
        } else if (option == "toggle") {
            state.left_open = !state.left_open
        }
        if (state.left_open) {
            document.getElementsByTagName("body")[0].classList.remove("left-hidden")
        } else {
            document.getElementsByTagName("body")[0].classList.add("left-hidden")
        }
    },
    rightside_bar(state, option) {

        if (option == "open") {
            state.right_open = true
        } else if (option == "close") {
            state.right_open = false
        } else if (option == "toggle") {
            state.right_open = !state.right_open
        }
        if (state.right_open) {
            document.getElementsByTagName("body")[0].classList.add("sidebar-right-opened")
        } else {
            document.getElementsByTagName("body")[0].classList.remove("sidebar-right-opened")
        }
    },

    routeChange(state, loader) {
        if (loader == "start") {
            state.preloader = true
        } else if (loader == "end") {
            state.preloader = false
        }
    },
    addWebReq(state, payload){
        state.activeReqs++
        if(state.activeReqs>0)
        state.bounce=true
        else
          state.bounce=false
      },
      decWebReq(state, payload){      
        state.activeReqs--
        if(state.activeReqs>0)
        state.bounce=true
        else
        state.bounce=false
      },
    setUser (state, payload) {
        if(payload.user!=null){
          state.user = payload          
        }
        else if (payload.payload!=null)
          state.user = {user:payload.payload}
        if(payload!=null && payload.user!=null  && payload.user.refreshToken!=null)
        {
        state.auth.idToken = payload.user.refreshToken      
        }
        else if(payload.payload!=null && payload.payload.refreshToken!=null)
        {
          state.auth.idToken = payload.payload.refreshToken
        }            
    },
    setLoading (state, payload) {
        state.loading = payload
      },
      clearError (state) {
        state.error = null
      },
    clearAuthData (state) {
    state.auth.idToken = null
    },
    authStateChanged(state,newState)
    {
    state.auth.signin.finished = newState
    },
    signupFinishedChanged(state,newState)
    {
    state.auth.signup.finished = newState
    },
    signupErrorChanged(state,newState)
    {
    state.auth.signup.error = newState
    },
    authStatusChanged(state,newState)
    {
    state.auth.signin.error = newState
    },
    forgotPasswordErrorChanged(state,newState)
    {
    state.auth.forgotPassword.error = newState
    },
    passwordResetErrorChanged(state,newState)
    {
    state.auth.passwordReset.error = newState
    },
    verifyUserErrorChanged(state,newState)
    {
    state.auth.verifyUser.error = newState
    },
    forgotPasswordEmailSentChanged(state,status)
    {
    state.auth.forgotPassword.finished = status
    },
    passwordWasResetChanged(state,status)
    {
    state.auth.passwordReset.finished = status
    },
    verifyUserChanged(state,status)
    {
    state.auth.verifyUser.finished = status
    },
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js